import gql from 'graphql-tag';

const userAssignmentDetail = gql`
  query userAssignmentDetail($classroomId: ID!, $courseAssetId: ID!) {
    userAssignmentDetail(classroomId: $classroomId, courseAssetId: $courseAssetId) {
      ... on UserAssignmentDetailResponse {
        courseRefId
        courseItemRefId
        courseAssetRefId
        userId
        classroomId
        type
        content {
          ... on AssignmentUrlContent {
            url
          }
          ... on AssignmentFileContent {
            fileName
            bucket
            provider
            key
          }
        }
        status
        resultStatus
        score
        studentComment
        reviewedComment
        submittedAt
        reviewedAt
        reviewedBy
        createdAt
        updatedAt
        id
        __typename
      }
    }
  }
`;

export { userAssignmentDetail };
